



































































































































import { JournalEntry } from "../../models/JournalEntry";
import JournalEntryLine from "../partials/JournalEntryLine.vue";
import ExternalMessage from "./ExternalMessage.vue";
import InternalComment from "./InternalComment.vue";
import moment from "moment";
import InterventionStatus from "./InterventionStatus.vue";
import SendNotificationModal from "../SendNotificationModal.vue";
import { JournalApi } from "../../api/JournalApi";
import SendEmailModal from "../SendEmailModal.vue";
import AbsenceModal from "../../employe/AbsenceModal.vue";
import InterventionModal from "../../intervention/InterventionModal.vue";
import StringUtils from "../../utils/StringUtils";
import { Intervention } from "../../models/Intervention";
import ECommunicationType = JournalEntry.ECommunicationType;
import ERecipientType = JournalEntry.ERecipientType;
import FacturationModal from "../../intervention/FacturationModal.vue";
import { Employe } from "../../models/Employe";
import Absence = Employe.Absence;
import JournalEntryModal from "../JournalEntryModal.vue";
import MoveEntryModal from "../MoveEntryModal.vue";
import BonDePassageModal from "../../intervention/BonDePassageModal.vue";
import EntryMailsModal from "../EntryMailsModal.vue";
import SignalementMailModal from "../../audit/SignalementMailModal.vue";
import { Audit } from "../../models/Audit";
import Evenement = Audit.Evenement;
import EvenementModal from "../../audit/EvenementModal.vue";
import ConfirmSuppression from "../../core/Modals/ConfirmSuppression";

export default {
    name: "EntryDetails",
    components: {
        EvenementModal,
        SignalementMailModal,
        BonDePassageModal,
        EntryMailsModal,
        MoveEntryModal,
        JournalEntryModal,
        FacturationModal,
        SendEmailModal,
        InterventionStatus,
        InternalComment,
        ExternalMessage,
        JournalEntryLine,
        SendNotificationModal,
        AbsenceModal,
        InterventionModal,
    },
    props: {
        entry: JournalEntry,
    },
    data() {
        return {
            JournalApi: new JournalApi(),
            entries: [],
            dates: [],
            sendNotificationModal: {
                show: false,
                parentId: null,
                requestId: null,
                object: null,
                defaultMessage: null,
                defaultObject: null,
                forwardedFiles: [],
                availableFiles: [],
            },
            sendEmailModal: {
                show: false,
                parentId: null,
                defaultSubject: null,
                defaultMessage: null,
                defaultFooter: null,
                forwardedFiles: [],
                availableFiles: [],
                defaultContact: null,
            },
            absenceModal: {
                isNew: false,
                absenceId: null,
                employeId: null,
            },
            interventionModal: {
                isNew: false,
                interventionId: null,
                defaultText: "",
            },
            facturationModal: {
                interventionId: null,
            },
            entryModal: {
                entryId: null,
                isNew: false,
                forceEditing: false,
            },
            moveEntryModal: {
                entry: null,
                show: false,
            },
            bonDePassageModal: {
                interventions: null,
                show: false,
            },
            mailsModal: {
                mails: [],
                show: false,
            },
            signalementModal: {
                evenement: null,
                show: false,
            },
            evenementModal: {
                evenementId: null,
                auditId: null,
            },
        };
    },
    watch: {
        entry: {
            immediate: true,
            handler: function () {
                if (!this.entry) {
                    return;
                }

                this.refreshComments();
            },
        },
    },
    methods: {
        // UI
        selectEntry(): void {
            this.$emit("select-entry", null);
        },
        isInternal(entry: JournalEntry): boolean {
            return entry.communication_type === ECommunicationType.none;
        },
        isFolder(entry: JournalEntry): boolean {
            return !entry.parent_id;
        },
        isExternal(entry: JournalEntry): boolean {
            return (
                entry.communication_type !== ECommunicationType.none &&
                entry.communication_type !==
                    ECommunicationType.intervention_status
            );
        },
        isInterventionStatus(entry: JournalEntry): boolean {
            return (
                entry.communication_type ===
                ECommunicationType.intervention_status
            );
        },
        shortDate(date: string): string {
            let objDate = moment(date, "DD/MM/YYYY");
            let res = "";
            if (objDate.isValid()) {
                res = objDate.format("DD/MM");
            }
            return res;
        },
        // Events
        sendNotification(entry: JournalEntry, object?: string): void {
            this.sendNotificationModal.parentId = entry.parent_id || entry.id;
            this.sendNotificationModal.requestId = entry.id;
            if (entry.attachment && entry.attachment.photos) {
                this.sendNotificationModal.forwardedFiles =
                    entry.attachment.photos;
            } else {
                this.sendNotificationModal.forwardedFiles = [];
            }
            this.sendNotificationModal.defaultMessage = entry.description;
            this.sendNotificationModal.defaultObject = entry.object;
            if (object) {
                this.sendNotificationModal.object = object;
            }
            this.sendNotificationModal.availableFiles = _.concat(
                this.entry.files,
                this.entry.get_comments_attachments()
            );

            this.sendNotificationModal.show = true;
        },
        onNotificationModalClose(): void {
            this.sendNotificationModal.show = false;
            this.refreshComments();
        },
        //
        showEntry(entry: JournalEntry) {
            this.entryModal.entryId = entry.id;
        },
        editEntry(entry: JournalEntry) {
            this.entryModal.entryId = entry.id;
            this.entryModal.forceEditing = true;
        },
        deleteEntry(entry: JournalEntry) {
            let self = this;
            let isCurrentFolder = entry.id === this.entry.id;
            ConfirmSuppression.demanderRaison(
                isCurrentFolder
                    ? "Voulez vous supprimer ce dossier&nbsp;?"
                    : "Voulez vous supprimer cette entrée&nbsp;?",
                isCurrentFolder
                    ? "Les commentaires du dossier seront également supprimés."
                    : ""
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.JournalApi.delete(entry.id, raison)
                    .then(function () {
                        if (isCurrentFolder) {
                            // Retour à la liste : le dossier ouvert n'existe plus.
                            self.$emit("select-entry", null);
                            swal(
                                "Le dossier a bien été supprimé !",
                                "",
                                "success"
                            );
                        } else {
                            self.refreshComments();
                            swal(
                                "La ligne a bien été supprimée !",
                                "",
                                "success"
                            );
                        }
                    })
                    .catch(function (error) {
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    });
            });
        },
        createEntry() {
            this.entryModal.isNew = true;
        },
        onEntryModalClose(): void {
            this.entryModal.entryId = null;
            this.entryModal.isNew = false;
            this.entryModal.forceEditing = false;
            this.refreshComments();
        },
        //
        moveEntry(entry: JournalEntry) {
            this.moveEntryModal.entry = entry;
            this.moveEntryModal.show = true;
        },
        closeMoveEntryModal(): void {
            this.moveEntryModal.show = false;
            this.moveEntryModal.entry = null;
            this.refreshComments();
        },
        //
        addAbsence(): void {
            this.absenceModal.isNew = true;
        },
        editAbsence(absence: Absence): void {
            this.absenceModal.absenceId = absence.id;
            this.absenceModal.employeId = absence.employe_id;
        },
        onAbsenceModalClose(): void {
            this.absenceModal.isNew = false;
            this.absenceModal.absenceId = null;
            this.absenceModal.employeId = null;
            this.refreshComments();
        },
        //
        addIntervention(entry: JournalEntry): void {
            this.interventionModal.interventionId = null;
            this.interventionModal.defaultText = StringUtils.html2text(
                entry.description
            );
            this.interventionModal.isNew = true;
        },
        showIntervention(entry: JournalEntry): void {
            this.interventionModal.isNew = false;
            this.interventionModal.defaultText = null;
            this.interventionModal.interventionId = entry.attachment_id;
        },
        onInterventionModalClose(data): void {
            let self = this;

            if (
                this.interventionModal.isNew &&
                data &&
                data instanceof Intervention
            ) {
                // intervention crée
                let promises = [];

                let newEntry = new JournalEntry({});

                newEntry.parent_id = this.entry.id;
                newEntry.comment_object =
                    JournalEntry.EObject.intervention_status;
                newEntry.communication_type =
                    JournalEntry.ECommunicationType.intervention_status;
                newEntry.description =
                    "<div class='comment-text'>" +
                    StringUtils.encodeHtmlEntities(data.titre) +
                    "</div>";
                newEntry.attachment_type =
                    JournalEntry.EAttachmentType.Intervention;
                newEntry.attachment_id = data.id;

                let employe = _.first(data.employes);
                if (employe) {
                    newEntry.recipient_type = ERecipientType.Employe;
                    newEntry.recipient_id = employe.id;
                }

                promises.push(this.JournalApi.save(newEntry));

                Promise.all(promises).then(function () {
                    self.refreshComments();
                });
            } else {
                self.refreshComments();
            }

            this.interventionModal.isNew = false;
            this.interventionModal.interventionId = null;
            this.interventionModal.defaultText = "";
        },
        //
        sendBonDePassage(entry: JournalEntry): void {
            this.bonDePassageModal.interventions = [
                new Intervention(entry.attachment),
            ];
            this.bonDePassageModal.show = true;
        },
        onBonDePassageModalClose(): void {
            this.bonDePassageModal.show = false;
            this.bonDePassageModal.interventions = null;
            this.refreshComments();
        },
        //
        showMails(entry: JournalEntry): void {
            this.mailsModal.mails = entry.displayableMails;
            this.mailsModal.show = true;
        },
        onMailsModalClose(): void {
            this.mailsModal.show = false;
            this.mailsModal.mails = [];
        },
        //
        sendSignalement(entry: JournalEntry): void {
            this.signalementModal.evenement = new Evenement(entry.attachment);
            this.signalementModal.show = true;
        },
        onSignalementModalClose(): void {
            this.signalementModal.show = false;
            this.signalementModal.evenement = null;
            this.refreshComments();
        },
        //
        editFacturation(entry: JournalEntry): void {
            this.facturationModal.interventionId =
                entry.attachment.intervention_id;
        },
        onFacturationModalClose(): void {
            this.facturationModal.interventionId = null;
        },
        //
        showEvenementModal(entry: JournalEntry): void {
            let evenement = new Evenement(entry.attachment);
            this.evenementModal.evenementId = evenement.id;
            this.evenementModal.auditId = evenement.audit_id;
        },
        onEvenementModalClose(): void {
            this.evenementModal.evenementId = null;
            this.evenementModal.auditId = null;
            this.refreshComments();
        },
        //
        sendEmail(entry: JournalEntry): void {
            this.sendEmailModal.parentId = entry.parent_id || entry.id;
            if (entry.attachment && entry.attachment.photos) {
                this.sendEmailModal.forwardedFiles = entry.attachment.photos;
            } else {
                this.sendEmailModal.forwardedFiles = [];
            }
            if (entry.client) {
                this.sendEmailModal.defaultSubject =
                    "Copropriété " + entry.client.nom;
                this.sendEmailModal.defaultContact = entry.client;
            } else {
                this.sendEmailModal.defaultSubject = "Notification";
            }
            if (this.entry.reference_id) {
                this.sendEmailModal.defaultSubject +=
                    " - ref:" + this.entry.reference_id;
            }
            if (this.isFolder(entry)) {
                this.sendEmailModal.defaultMessage = "";
                this.sendEmailModal.defaultFooter = "";
            } else if (
                entry.attachment_type === JournalEntry.EAttachmentType.Audit
            ) {
                this.sendEmailModal.defaultFooter = "";
                this.sendEmailModal.defaultMessage =
                    "Lors de notre contrôle de ce jour, nous avons pu constater les faits suivants :<br/>" +
                    entry.description;
            } else if (this.isExternal(entry)) {
                this.sendEmailModal.defaultMessage = "";
                this.sendEmailModal.defaultFooter = entry.description;
            } else {
                this.sendEmailModal.defaultMessage = entry.description;
                this.sendEmailModal.defaultFooter = "";
            }
            this.sendEmailModal.availableFiles = _.concat(
                this.entry.files,
                this.entry.get_comments_attachments()
            );

            this.sendEmailModal.show = true;
        },
        onEmailModalClose(): void {
            this.sendEmailModal.show = false;
            this.sendEmailModal.defaultContact = null;
            this.refreshComments();
        },
        //
        doAction(action: JournalEntry.UIActionType, entry: JournalEntry) {
            if (action === JournalEntry.UIActionType.send_notification) {
                this.sendNotification(entry);
            } else if (action === JournalEntry.UIActionType.send_email) {
                this.sendEmail(entry);
            } else if (
                action === JournalEntry.UIActionType.intervention_request
            ) {
                this.sendNotification(
                    entry,
                    JournalEntry.EObject.intervention_request
                );
            } else if (action === JournalEntry.UIActionType.create_entry) {
                this.createEntry();
            } else if (action === JournalEntry.UIActionType.show_entry) {
                this.showEntry(entry);
            } else if (action === JournalEntry.UIActionType.edit_entry) {
                this.editEntry(entry);
            } else if (action === JournalEntry.UIActionType.delete_entry) {
                this.deleteEntry(entry);
            } else if (action === JournalEntry.UIActionType.move_entry) {
                this.moveEntry(entry);
            } else if (action === JournalEntry.UIActionType.create_absence) {
                this.addAbsence();
            } else if (action === JournalEntry.UIActionType.edit_absence) {
                this.editAbsence(entry.attachment);
            } else if (
                action === JournalEntry.UIActionType.create_intervention
            ) {
                this.addIntervention(entry);
            } else if (action === JournalEntry.UIActionType.show_intervention) {
                this.showIntervention(entry);
            } else if (action === JournalEntry.UIActionType.edit_facturation) {
                this.editFacturation(entry);
            } else if (
                action === JournalEntry.UIActionType.send_bon_de_passage
            ) {
                this.sendBonDePassage(entry);
            } else if (action === JournalEntry.UIActionType.send_signalement) {
                this.sendSignalement(entry);
            } else if (action === JournalEntry.UIActionType.show_evenement) {
                this.showEvenementModal(entry);
            } else if (action === JournalEntry.UIActionType.show_mails) {
                this.showMails(entry);
            }
        },
        // Data
        initLists(comments: Array<JournalEntry>): void {
            this.entries = _.chain(comments)
                .groupBy("creation_date_str")
                .mapValues(function (list) {
                    return _.orderBy(list, "created_at", "desc");
                })
                .value();
            this.dates = _.chain(comments)
                .orderBy("created_at", "desc")
                .map("creation_date_str")
                .uniq()
                .value();
        },
        refreshComments(): void {
            let self = this;

            self.entries = [];
            self.dates = [];

            this.JournalApi.get(self.entry.id, {
                include:
                    "comments,comments.attachment.client.related_contacts,attachment.client.related_contacts,comments.client.related_contacts",
            }).then(function (res) {
                self.initLists(res.comments);
                self.$nextTick(function () {
                    self.fixDatePosition();
                });
            });
        },
        // UI
        fixDatePosition(): void {
            let entryHead = document.getElementById("entryHead");
            if (!entryHead) {
                return;
            }
            let headerHeight = entryHead.offsetHeight;
            let dateTds = document.querySelectorAll("td.date");
            _.each(dateTds, function (dateTd) {
                dateTd.style.top = 5 + headerHeight + "px";
            });
        },
    },
};
